"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  [![Run in Postman](https://run.pstmn.io/button.svg)](https://app.getpostman.com/run-collection/614feab5c108d292bffa#?env%5BStacks%20Blockchain%20API%5D=W3sia2V5Ijoic3R4X2FkZHJlc3MiLCJ2YWx1ZSI6IlNUMlRKUkhESE1ZQlE0MTdIRkIwQkRYNDMwVFFBNVBYUlg2NDk1RzFWIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJibG9ja19pZCIsInZhbHVlIjoiMHgiLCJlbmFibGVkIjp0cnVlfSx7ImtleSI6Im9mZnNldCIsInZhbHVlIjoiMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfdHgiLCJ2YWx1ZSI6IjIwMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfYmxvY2siLCJ2YWx1ZSI6IjMwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJ0eF9pZCIsInZhbHVlIjoiMHg1NDA5MGMxNmE3MDJiNzUzYjQzMTE0ZTg4NGJjMTlhODBhNzk2MzhmZDQ0OWE0MGY4MDY4Y2RmMDAzY2RlNmUwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9pZCIsInZhbHVlIjoiU1RKVFhFSlBKUFBWRE5BOUIwNTJOU1JSQkdRQ0ZOS1ZTMTc4VkdIMS5oZWxsb193b3JsZFxuIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJidGNfYWRkcmVzcyIsInZhbHVlIjoiYWJjIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9hZGRyZXNzIiwidmFsdWUiOiJTVEpUWEVKUEpQUFZETkE5QjA1Mk5TUlJCR1FDRk5LVlMxNzhWR0gxIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9uYW1lIiwidmFsdWUiOiJoZWxsb193b3JsZCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWFwIiwidmFsdWUiOiJzdG9yZSIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWV0aG9kIiwidmFsdWUiOiJnZXQtdmFsdWUiLCJlbmFibGVkIjp0cnVlfV0=)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNetworkBlockTimeByNetworkNetworkEnum = exports.InfoApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class InfoApi extends runtime.BaseAPI {
    /**
     * Get Core API information
     * Get Core API info
     */
    async getCoreApiInfoRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CoreNodeInfoResponseFromJSON(jsonValue));
    }
    /**
     * Get Core API information
     * Get Core API info
     */
    async getCoreApiInfo() {
        const response = await this.getCoreApiInfoRaw();
        return await response.value();
    }
    /**
     * Get a given network\'s target block time
     */
    async getNetworkBlockTimeByNetworkRaw(requestParameters) {
        if (requestParameters.network === null || requestParameters.network === undefined) {
            throw new runtime.RequiredError('network', 'Required parameter requestParameters.network was null or undefined when calling getNetworkBlockTimeByNetwork.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/info/network_block_time/{network}`.replace(`{${"network"}}`, encodeURIComponent(String(requestParameters.network))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.NetworkBlockTimeResponseFromJSON(jsonValue));
    }
    /**
     * Get a given network\'s target block time
     */
    async getNetworkBlockTimeByNetwork(requestParameters) {
        const response = await this.getNetworkBlockTimeByNetworkRaw(requestParameters);
        return await response.value();
    }
    /**
     * Get the network target block time
     */
    async getNetworkBlockTimesRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/info/network_block_times`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.NetworkBlockTimesResponseFromJSON(jsonValue));
    }
    /**
     * Get the network target block time
     */
    async getNetworkBlockTimes() {
        const response = await this.getNetworkBlockTimesRaw();
        return await response.value();
    }
    /**
     * Get Proof of Transfer (PoX) information. Can be used for Stacking.
     * Get PoX details
     */
    async getPoxInfoRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/pox`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CoreNodePoxResponseFromJSON(jsonValue));
    }
    /**
     * Get Proof of Transfer (PoX) information. Can be used for Stacking.
     * Get PoX details
     */
    async getPoxInfo() {
        const response = await this.getPoxInfoRaw();
        return await response.value();
    }
    /**
     * Get Blockchain API status
     * Get Blockchain API status
     */
    async getStatusRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Get Blockchain API status
     * Get Blockchain API status
     */
    async getStatus() {
        await this.getStatusRaw();
    }
    /**
     * Get total and unlocked STX supply
     */
    async getStxSupplyRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.height !== undefined) {
            queryParameters['height'] = requestParameters.height;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/stx_supply`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GetStxSupplyResponseFromJSON(jsonValue));
    }
    /**
     * Get total and unlocked STX supply
     */
    async getStxSupply(requestParameters) {
        const response = await this.getStxSupplyRaw(requestParameters);
        return await response.value();
    }
    /**
     * Get circulating STX supply in plain text format
     */
    async getStxSupplyCirculatingPlainRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/stx_supply/circulating/plain`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.TextApiResponse(response);
    }
    /**
     * Get circulating STX supply in plain text format
     */
    async getStxSupplyCirculatingPlain() {
        const response = await this.getStxSupplyCirculatingPlainRaw();
        return await response.value();
    }
    /**
     * Get total STX supply in plain text format
     */
    async getStxSupplyTotalSupplyPlainRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/stx_supply/total/plain`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.TextApiResponse(response);
    }
    /**
     * Get total STX supply in plain text format
     */
    async getStxSupplyTotalSupplyPlain() {
        const response = await this.getStxSupplyTotalSupplyPlainRaw();
        return await response.value();
    }
    /**
     * Get total and unlocked STX supply (results formatted the same as the legacy 1.0 API)
     */
    async getTotalStxSupplyLegacyFormatRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.height !== undefined) {
            queryParameters['height'] = requestParameters.height;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/stx_supply/legacy_format`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GetStxSupplyLegacyFormatResponseFromJSON(jsonValue));
    }
    /**
     * Get total and unlocked STX supply (results formatted the same as the legacy 1.0 API)
     */
    async getTotalStxSupplyLegacyFormat(requestParameters) {
        const response = await this.getTotalStxSupplyLegacyFormatRaw(requestParameters);
        return await response.value();
    }
}
exports.InfoApi = InfoApi;
/**
    * @export
    * @enum {string}
    */
var GetNetworkBlockTimeByNetworkNetworkEnum;
(function (GetNetworkBlockTimeByNetworkNetworkEnum) {
    GetNetworkBlockTimeByNetworkNetworkEnum["testnet"] = "testnet";
    GetNetworkBlockTimeByNetworkNetworkEnum["mainnet"] = "mainnet";
})(GetNetworkBlockTimeByNetworkNetworkEnum = exports.GetNetworkBlockTimeByNetworkNetworkEnum || (exports.GetNetworkBlockTimeByNetworkNetworkEnum = {}));
//# sourceMappingURL=InfoApi.js.map